import { setCookie } from './';
import { getUrlParameter } from './';

export const setMCID = () => {
  const mcid = getUrlParameter('utm_mcid') || '3535935';
  setCookie('marketing', JSON.stringify({ mcid }));
};
